import SiteChrome from "./SiteChrome.jsx";
import SearchPage from "./SearchPage.jsx";
import OrdersPage from "./OrdersPage.jsx";
import ThankYouPage from "./ThankYouPage.jsx";

const PAGES = {
  search: SearchPage,
  orders: OrdersPage,
  thankYou: ThankYouPage,
};

export default function App({ data }) {
  const Page = PAGES[data.page];
  if (!Page) return null;

  const page = <Page data={data} />;

  // VITE EN VOGUE supplies its own header and footer around the iframe.
  return data.chrome === "bare" ? (
    <div className="container">{page}</div>
  ) : (
    <SiteChrome contact={data.contact} year={data.year}>
      {page}
    </SiteChrome>
  );
}
